import {AMENITY_ACCESS_LOG_FEATURE_KEYS} from "@/src/modules/amenities/lib/amenity-config";
import {citationsService} from "@/src/modules/citations/services";
import {featureService} from "@/src/modules/core/services/feature";
import {meService} from "@/src/modules/core/services/me";
import {permanentParkingService} from "@/src/modules/permanent-parking/services";
import {safelistingsService} from "@/src/modules/safelistings/services";

/** Same gate as nav: property section granted + `{resource} show`. */
export function getResidentHomePillarVisibility() {
  return {
    permanentPermits:
      featureService.isPermanentParkingEnabled && permanentParkingService.getIsShowEnabled(),
    safelistings:
      featureService.isSafelistingsEnabled && safelistingsService.getIsShowEnabled(),
    citations: featureService.isCitationsEnabled && citationsService.getCanShow(),
    amenities:
      AMENITY_ACCESS_LOG_FEATURE_KEYS.some((key) => featureService.getIsFeatureEnabled(key)) &&
      meService.getHasPermission("property_amenity show"),
  };
}
